export default {
  en: {
    'pages.filing.summary-page.tab.draft-return': 'Draft Return',
    'pages.filing.summary-page.tab.prepare': 'Prepare',
    'pages.filing.summary-page.tab.payment': 'Payment',
    'pages.filing.summary-page.supporting-docs.title': 'Supporting Documents',
    'pages.filing.summary-page.buttons.attach': 'Attach files',
    'pages.summary-page.buttons.notes': 'Notes & issues',
    'pages.summary-page.tabs.messages': 'Messages',
    'pages.filing.summary-page.intrastat.transaction-panel.buttons.data-approved':
      'Data approved. Please proceed to one of the 2 steps below.',
    'pages.filing.summary-page.intrastat.transaction-panel.button.send-for-review':
      'Send for review',
    'pages.filing.summary-page.intrastat.transaction-panel.button.send-for-filing':
      'Send for filing',
    'pages.filing.summary-page.tab.draft-return.unavailable.title': 'Draft Return Unavailable',
    'pages.filing.summary-page.tab.draft-return.unavailable.description':
      'The draft return will only be available after it has been generated.',
    'pages.filing.summary-page.tab.payment.unavailable.title': 'Payment Information Unavailable',
    'pages.filing.summary-page.tab.payment.unavailable.description':
      'Payment information will only become available when a draft return is ready.',
  },
};
